import { render, staticRenderFns } from "./finalize.vue?vue&type=template&id=242d4094&scoped=true&"
import script from "./finalize.vue?vue&type=script&lang=js&"
export * from "./finalize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d4094",
  null
  
)

export default component.exports